import { useState } from 'react'

import { ResourceHeader } from '@factorialco/f0-react/dist/experimental'
import { Pencil } from '@factorialco/f0-react/icons/app'
import { JobLevelRateDetailsDocument } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { getCurrencySymbolFromCode } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'

import EditJobRatesSidepanel from 'modules/project_management/components/tables/JobsAndRatesDataCollection/EditJobRatesSidepanel'
import { convertCentsToPercentage } from 'modules/project_management/lib/profitabilityCalculations'

type Props = {
  billingRateCents: number
  canManageRate: boolean
  costRateCents: number
  currency: string
  roleName: string
  levelName: string
  markupPercentageCents: number
  marginPercentageCents: number
  resourceId: string
  resourceType: string
}

export const RoleDetailsHeader = ({
  billingRateCents,
  canManageRate,
  costRateCents,
  currency,
  roleName,
  levelName,
  markupPercentageCents,
  marginPercentageCents,
  resourceId,
  resourceType,
}: Props) => {
  const [showEditJobRatesSidepanel, setShowEditJobRatesSidepanel] = useState<boolean>(false)
  const jobLevelInfo = {
    name: levelName,
    resourceId,
    resourceType,
  }

  return (
    <>
      <ResourceHeader
        title={roleName}
        metadata={[
          {
            label: i18n.t('project_management.headers.seniority'),
            value: {
              type: 'text',
              content: levelName,
            },
          },
          {
            label: i18n.t('project_management.headers.max_cost_rate'),
            value: {
              type: 'text',
              content: (costRateCents / 100).toString() + getCurrencySymbolFromCode(currency),
            },
          },
          {
            label: i18n.t('project_management.headers.bill_rate'),
            value: {
              type: 'text',
              content: (billingRateCents / 100).toString() + getCurrencySymbolFromCode(currency),
            },
          },
          {
            label: i18n.t('project_management.headers.markup'),
            value: {
              type: 'text',
              content: convertCentsToPercentage(markupPercentageCents) + '%',
            },
          },
          {
            label: i18n.t('project_management.headers.margin'),
            value: {
              type: 'text',
              content: (marginPercentageCents / 100).toFixed(2) + '%',
            },
          },
        ]}
        primaryAction={{
          label: i18n.t('project_management.job_level_employees.main_action_button'),
          icon: Pencil,
          isVisible: canManageRate,
          onClick: () => {
            track(trackingEvents.projectManagement.jobsAndRates.clickOnEditRoleRate, {
              origin: 'from_job_level_table',
            })
            setShowEditJobRatesSidepanel(true)
          },
        }}
      />
      <EditJobRatesSidepanel
        showSidePanel={showEditJobRatesSidepanel}
        onClose={() => setShowEditJobRatesSidepanel(false)}
        refetchQueries={[JobLevelRateDetailsDocument]}
        jobLevelInfo={jobLevelInfo}
      />
    </>
  )
}
